import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";
import { reclaimWinRateTimeWindow } from "./reclaim-win-rate-time-window";

/**
 * One row per *display-canonical* bank label, sorted descending by
 * total volume (won + lost). The handler runs `groupBankNameForDisplay`
 * over raw `bank_name` rows and sums collisions, so the same canonical
 * label never appears twice. Null / unknown bank rows surface under the
 * literal label "Unknown".
 */
export const reclaimWinRateByBankRowSchema = z.object({
  bankName: z.string(),
  won: z.number().int(),
  lost: z.number().int(),
  wonExcludingProtected: z.number().int(),
  lostExcludingProtected: z.number().int(),
});

export interface ReclaimWinRateByBankRow extends z.infer<
  typeof reclaimWinRateByBankRowSchema
> {}

export const getReclaimWinRateByBank = unaryRpc({
  name: "getReclaimWinRateByBank" as const,
  input: z.object({ timeWindow: z.enum(reclaimWinRateTimeWindow) }),
  output: z.object({ rows: z.array(reclaimWinRateByBankRowSchema) }),
});
